export default __webpack_public_path__ + "6e22e5a844b2e0144f2fe84e20813666.svg";